import React from "react"
import { IMG } from "../../../../common/CONST"
import { download, getFormattedDate, spacedNum } from "../../../../common/CommonHelper"

import { ICurrencyReplenishmentDto } from "@/types/replenishment/ICurrencyReplenishmentDto"

export const CRTab: React.FC<{
  replenishment: ICurrencyReplenishmentDto
  setReplenishment: (r: ICurrencyReplenishmentDto) => void
  crAcceptance: (accepted: boolean) => void
}> = ({ replenishment }) => {
  return (
    <>
      <div className="container">
        <div className="container-pop-up">
          <ul className="form-full">
            <li className="form-block-popup width-3-blocks justifyBetween">
              <h4 className="heading-chapter">Сумма к зачислению</h4>
              <p className="valute-deal-user--small">{spacedNum(Number(replenishment.creditedAmount) / 100)}</p>
            </li>
            <li className="form-block-popup width-3-blocks justifyBetween">
              <h4 className="heading-chapter">Валюта пополнения</h4>
              <p className="valute-deal-user--small">{replenishment.currencyRequest?.currency}</p>
            </li>
            <li className="form-block-popup width-3-blocks justifyBetween">
              <h4 className="heading-chapter">Сумма комиссии</h4>
              <p className="valute-deal-user--small">
                {replenishment.retainedAmount ? spacedNum(Number(replenishment.retainedAmount) / 100) : "-"}
              </p>
            </li>
          </ul>

          <ul className="form-full">
            <li className="form-block-popup width-3-blocks">
              <h4 className="heading-chapter">Платежные поручения</h4>
              {replenishment.slipFiles && replenishment.slipFiles?.length > 0 ? (
                replenishment.slipFiles.map((f, index) => (
                  <fieldset className="fieldset-fit">
                    <legend></legend>
                    <button className="btn download-btn" key={index} onClick={() => download(f.id, "PAYMENT_ORDER")}>
                      <img src={IMG.download} alt="" />
                      {`Платежное поручение №${index + 1}`}
                    </button>
                  </fieldset>
                ))
              ) : (
                <></>
              )}
              <div className="flex-row-10">
                <button
                  className="btn black-btn"
                  onClick={() => window.open(`/currency-replenishment/${replenishment.id}/bill`)}
                >
                  Открыть счет
                </button>
              </div>
            </li>

            <li className="form-block-popup width-3-blocks">
              <h4 className="heading-chapter">Контракт на валютное пополнение</h4>

              <fieldset>
                <legend>Дата</legend>
                <p className="text-form">{getFormattedDate(replenishment.contractDate || "")}</p>
              </fieldset>
              <fieldset>
                <legend>Номер</legend>
                <p className="text-form">№{replenishment.contractNumber}</p>
              </fieldset>
              <fieldset className="fieldset-fit">
                <legend></legend>
                <button
                  className="btn download-btn"
                  onClick={() => download(replenishment.id?.toString(), "CLIENT_CONTRACT")}
                >
                  <img src={IMG.download} alt="" />
                  Скачать
                </button>
              </fieldset>
            </li>

            <li className="form-block-popup width-3-blocks">
              <h4 className="heading-chapter">Валютный плательщик</h4>
              <p className="valute-deal-user">{replenishment.currencyRequest?.currencyPayerName}</p>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
